export default __webpack_public_path__ + "static/media/icon-apple-logo.62617234.svg";